module.exports = __webpack_public_path__ + "img/icon-chevron-down.6d0f874c.svg";